import {Button, DatePicker, Form} from 'antd';
import i18n from 'i18next';
import isNil from 'lodash/isNil';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, {useMemo} from 'react';

import {moreDaysValues} from '@/components/DateRangeComponent';
import {getRangeByDays} from '@/components/DateRangeComponent/utils';

import FilterContent from '../../FilterContent';
import {
  getLastMonth,
  getLastSevenDays,
  getLastThirtyDays,
  getNever,
  getThisMonth,
  getThisWeek,
  getTodayRange
} from './utils';

const {RangePicker} = DatePicker;

const DateSelector = ({t, value, onChange}) => {

  return (<>
    <div className="flex flex-wrap p-1">
      <Button className="m-1 px-2" onClick={() => onChange(getTodayRange())}>
        {t('dateFilter.today')}
      </Button>
      <Button className="m-1 px-2" onClick={() => onChange(getThisWeek())}>
        {t('dateFilter.thisWeek')}
      </Button>
      <Button className="m-1 px-2" onClick={() => onChange(getLastSevenDays())}>
        {t('dateFilter.lastSevenDays')}
      </Button>
      <Button className="m-1 px-2" onClick={() => onChange(getThisMonth())}>
        {t('dateFilter.thisMonth')}
      </Button>
      <Button className="m-1 px-2" onClick={() => onChange(getLastThirtyDays())}>
        {t('dateFilter.lastThirtyDays')}
      </Button>
      <Button className="m-1 px-2" onClick={() => onChange(getLastMonth())}>
        {t('dateFilter.lastMonth')}
      </Button>
      {moreDaysValues?.map((days, index) => <Button
        key={index}
        className="m-1 px-2"
        onClick={() => onChange(getRangeByDays(days))}>
        {t('dateFilter.more' + days + 'days')}
      </Button>)}
      <Button className="m-1 px-2" onClick={() => onChange(getNever())}>
        {t('dateFilter.never')}
      </Button>
    </div>
    <div className="p-2">
      <RangePicker className="w-full" value={value} onChange={onChange}/>
    </div>
  </>);
};

DateSelector.propTypes = {
  t: PropTypes.func,
  value: PropTypes.any,
  onChange: PropTypes.func,
};

export const DateRangeComponent = ({filter, t, applyFilter}) => {

  return (
    <div style={{maxWidth: '20rem'}}>
      <Form onFinish={({value}) => {
        if (value) {
          const [from, to] = value;

          const query = {
            field: filter.field,
            type: 'RANGE',
            isDate: true,
          };

          if (from)
            query.from = from.startOf('date').toISOString();
          if (to)
            query.to = to.endOf('date').toISOString();

          applyFilter(query);
        } else {
          applyFilter({
            field: filter.field,
            type: 'TERM',
            value: null,
          });
        }
      }}>
        <FilterContent t={t}>
          <Form.Item name="value" className="m-0">
            <DateSelector t={t}/>
          </Form.Item>
        </FilterContent>
      </Form>
    </div>
  );
};

DateRangeComponent.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  applyFilter: PropTypes.func,
};

export const ValueDateRange = ({filterValue}) => {
  return useMemo(() => {
    const {to, from, value, field} = filterValue;
    if (!isNil(from) && !isNil(to)) {
      return `${moment(from).format('LL').toString()} - ${moment(to).format('LL').toString()}`;
    } else if (isNil(from) && !isNil(to)) {
      return `Hasta ${moment(to).format('LL').toString()}`;
    } else if (!isNil(from) && isNil(to)) {
      return `Desde ${moment(from).format('LL').toString()}`;
    }
    if (field && !value) {
      return i18n.t('dateFilter.never');
    }
    return null;
  }, [filterValue]);
};

ValueDateRange.propTypes = {
  filter: PropTypes.object,
  t: PropTypes.func,
  filterValue: PropTypes.any,
};
